import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-56839541"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "location-content-items-container" }
const _hoisted_2 = { class: "location-details" }
const _hoisted_3 = {
  key: 0,
  class: "location-icon"
}
const _hoisted_4 = { class: "location-data" }
const _hoisted_5 = { class: "location-address line-1" }
const _hoisted_6 = { class: "location-address" }
const _hoisted_7 = { class: "location-stats flex-row" }
const _hoisted_8 = { class: "bold" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = { class: "bold" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = { class: "bold" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_14 = { class: "bold" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-angle-right" }, null, -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = { class: "trailer-fault-details" }
const _hoisted_19 = {
  key: 0,
  class: "trailer-fault-container"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "trailer-fault-text red-circle" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "trailer-fault-title" }, "Cargo Sensor Issue"),
  /*#__PURE__*/_createTextVNode(" This may affect trailer availability ")
], -1))
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = {
  key: 1,
  class: "trailer-fault-container"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "trailer-fault-text orange-circle" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "trailer-fault-title" }, "Needs DOT Inspection"),
  /*#__PURE__*/_createTextVNode(" Requires inspection before trailer use ")
], -1))
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = {
  key: 2,
  class: "horizontal-line"
}
const _hoisted_26 = { class: "timestamp-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.isReserved)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          class: _normalizeClass(["location-title", { 'mark-green': _ctx.isReserved }])
        }, _toDisplayString(_ctx.locationTitle), 3),
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.locationAddressLineOne), 1),
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.locationAddressLineTwo), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", null, [
        _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.distance), 1),
        _createTextVNode(),
        _hoisted_9,
        _createTextVNode(" Mile" + _toDisplayString(`${
                        _ctx.displayedResult.distance.toFixed(1) === '1.0' ? '' : 's'
                    }`), 1)
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.travelTime), 1),
        _createTextVNode(),
        _hoisted_11,
        _createTextVNode(" Min ")
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.arrivalTime), 1),
        _createTextVNode(),
        _hoisted_13,
        _createTextVNode(" Arrival ")
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.totalTrailerText), 1),
        _createTextVNode(),
        _hoisted_15,
        _createTextVNode(" Trailer" + _toDisplayString(_ctx.displayedResult.trailers.length > 1 ? 's' : ''), 1)
      ]),
      (_ctx.isCustomerLocation)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "location-trailer-list",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onViewTrailers && _ctx.onViewTrailers(...args)))
          }, _hoisted_17))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_18, [
      (_ctx.hasCargoSensorError === true && !_ctx.isCustomerLocation)
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, _hoisted_21))
        : _createCommentVNode("", true),
      (
                    (_ctx.hasDotExpired && !_ctx.isCustomerLocation) ||
                    _ctx.hasExclusivelyDotExpiredTrailers
                )
        ? (_openBlock(), _createElementBlock("div", _hoisted_22, _hoisted_24))
        : _createCommentVNode("", true),
      (
                    (_ctx.hasAnyFault && !_ctx.isCustomerLocation) ||
                    _ctx.hasExclusivelyDotExpiredTrailers
                )
        ? (_openBlock(), _createElementBlock("div", _hoisted_25))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.lastUpdated), 1)
    ])
  ]))
}